export default function getHasChildren(_) {
  function hasChildren(obj, childrenPath) {
    return _.some(childrenPath, cp => {
      var children = _.get(obj, cp);

      return !_.isEmpty(children);
    });
  }

  return hasChildren;
}